import React from 'react';
import PropTypes from 'prop-types';
import { isClip, isEpisode } from 'helpers/ContentHelper';
import { isSeriesCollection } from '../../../../SeriesDetailHelpers';

export const Header = props => {
  const { style, videoType, currentSeason, seriesType, tabName, videosList, newsHeadline } = props;
  const { seriesDetail_clipsHeader: clipsHeaderText } = window.Language;
  const showsHeaderText = currentSeason && `Season ${currentSeason}`;
  let headerClass;
  let headerTitle;

  if (isSeriesCollection(seriesType)) {
    headerClass = style.headerTitle;
    headerTitle = tabName || showsHeaderText;
  } else if (isEpisode(videoType)) {
    headerClass = style.seasonTitle;
    headerTitle = newsHeadline || showsHeaderText;
  } else if (isClip(videoType)) {
    headerClass = style.headerTitle;
    headerTitle = clipsHeaderText;
  }

  const showHeader = headerClass && headerTitle && videosList.length > 0;

  if (!showHeader) return null;

  return (
    <div data-test="videos-tab-header">
      <h2 data-test="videos-tab-header-title" className={headerClass}>
        {headerTitle}
      </h2>
    </div>
  );
};

Header.defaultProps = {
  currentSeason: null,
  newsHeadline: null,
  seriesType: null,
  style: {},
  tabName: null,
  videosList: [],
  videoType: {},
};

Header.propTypes = {
  currentSeason: PropTypes.number,
  newsHeadline: PropTypes.string,
  seriesType: PropTypes.string,
  style: PropTypes.shape({}),
  tabName: PropTypes.string,
  videosList: PropTypes.arrayOf(PropTypes.shape({})),
  videoType: PropTypes.shape({}),
};

export default Header;
